import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Checkbox, DialogOverlay, DialogOverlayActions, Paragraph } from '@fs/zion-ui'
import { updateArtifact } from '../../../services/artifactService'
import useNotifications from '../../../hooks/useNotifications'
import { SCREENING_STATE } from '../util/artifactsConstants'
import RestrictArtifactsDialogOptions from './RestrictArtifactsDialogOptions'

export default function RestrictArtifactOverlay({ artifactId, onSuccess, ...overlay }) {
  const { t } = useTranslation()
  const { error, ok } = useNotifications()
  const [pendingScreeningTag, setPendingScreeningTag] = useState('')
  const [sendEmail, setSendEmail] = useState(true)

  const submitOnClick = async () => {
    overlay.close()
    try {
      await updateArtifact(
        {
          id: artifactId,
          ID: artifactId,
          screeningState: SCREENING_STATE.RESTRICTED,
          screeningTag: pendingScreeningTag,
        },
        sendEmail
      )
      ok(t('success', 'Success'))
      onSuccess && onSuccess()
    } catch (err) {
      error(
        t('artifacts.error.errorRestrictingArtifact', {
          defaultValue: `Error restricting artifact: ${err.message || ''}`,
          message: err.message || '',
        }),
        err
      )
    }
  }

  return (
    <DialogOverlay title={t('action.restrict', 'Restrict')} {...overlay}>
      <Paragraph size="sm">
        {t('artifacts.restrictConfirmation', 'Are you sure you want to restrict this artifact?')}
      </Paragraph>
      <RestrictArtifactsDialogOptions
        pendingScreeningTag={pendingScreeningTag}
        setPendingScreeningTag={setPendingScreeningTag}
      />
      <Checkbox
        name="NotifyPatronViaEmailCheckbox"
        label={t('artifacts.restrictAllNotifyPatron', 'Notify patron via email')}
        checked={sendEmail}
        onChange={(e) => setSendEmail(e.target.checked)}
      />
      <DialogOverlayActions>
        <Button onClick={submitOnClick} emphasis="high" disabled={!pendingScreeningTag}>
          {t('action.submit', 'Submit')}
        </Button>
        <Button onClick={overlay.close}>{t('action.cancel', 'Cancel')}</Button>
      </DialogOverlayActions>
    </DialogOverlay>
  )
}
